import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;

/** Matches Tailwind `lg` — compact nav (mobile header + bottom bar) below this width. */
const COMPACT_NAV_BREAKPOINT = 1024;

function useIsBelowWidth(breakpoint: number): boolean {
  const [below, setBelow] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);

    const sync = () => {
      setBelow(window.innerWidth < breakpoint);
    };

    mql.addEventListener('change', sync);
    sync();

    return () => mql.removeEventListener('change', sync);
  }, [breakpoint]);

  return below;
}

export function useIsMobile(): boolean {
  return useIsBelowWidth(MOBILE_BREAKPOINT);
}

export function useIsMobileNav(): boolean {
  return useIsBelowWidth(COMPACT_NAV_BREAKPOINT);
}
